import React, {useEffect, useRef, useState} from 'react';

import utilsService from '../../../services/utilsService';
import VIDABOO_CONSTANTS from '../../../config/consts';

import './consentHtmlTextComponent.css';

const ConsentHtmlTextComponent = ({
  shouldShowReadMore = false,
  consentTxt = '',
  setShowReadMoreBtn = () => {},
}) => {
  const consentWrapRef = useRef(null);
  const [htmlTxt, setHtmlTxt] = useState(null);

  useEffect(() => {
    if (shouldShowReadMore) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            handleContentOverFlow();
          }
        }
      });
      if (consentWrapRef?.current && consentWrapRef?.current?.hasChildNodes()) {
        handleContentOverFlow();
      }
      observer.observe(consentWrapRef.current, {childList: true});
      window.addEventListener('resize', handleContentOverFlow);
      return () => {
        observer.disconnect();
        window.removeEventListener('resize', handleContentOverFlow);
      };
    }
  }, []);

  useEffect(() => {
    const htmlTxt = getHTMLMessage(consentTxt);
    setHtmlTxt(htmlTxt);
  }, [consentTxt]);

  const handleContentOverFlow = () => {
    if (consentWrapRef?.current) {
      const {clientHeight, scrollHeight} = consentWrapRef.current;
      setShowReadMoreBtn(scrollHeight > clientHeight);
    } else {
      setShowReadMoreBtn(false);
    }
  };

  const getHTMLMessage = (msg) => {
    if (!msg) return null;
    let newMessage = msg;
    if (utilsService.checkIfHTML(msg) || msg.match(/@/)) {
      newMessage = msg.replace(
        VIDABOO_CONSTANTS.VALIDATION_PATTERNS.ANY_EMAIL_IN_STRING,
        (url) => {
          return `<a href=mailto:"${url}">${url}</a>`;
        },
      );
    }

    newMessage = newMessage.replace(
      VIDABOO_CONSTANTS.VALIDATION_PATTERNS.ANY_URL,
      (url) => {
        let fullUrl = url;
        if (!url.match(/^http/) && !fullUrl.match(/@/)) {
          fullUrl = 'http://' + fullUrl;
        }
        if (fullUrl.match(/@/) || utilsService.checkIfHTML(fullUrl))
          return fullUrl;
        return `<a href=${fullUrl} target="_blank" >${url}</a>`;
      },
    );

    if (utilsService.shouldRenderAsHTML(newMessage)) {
      newMessage = newMessage.replace(/<iframe/g, '&lt;iframe');
      newMessage = newMessage.replace(/<script/g, '&lt;script');
      newMessage = newMessage.replace(/<\/script/g, '&lt;/script');
    }

    return utilsService.shouldRenderAsHTML(newMessage) ? (
      <div
        dir="auto"
        className="et-chat-link"
        dangerouslySetInnerHTML={{__html: newMessage}}
      />
    ) : (
      <div dir="auto" className="et-chat-link">
        {newMessage}
      </div>
    );
  };

  return (
    <div ref={consentWrapRef} className="et-v2-consent-html-text">
      {htmlTxt}
    </div>
  );
};

export default ConsentHtmlTextComponent;
